export default "__VITE_ASSET__0c34f174__"